import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlertComponent } from './alerts/alert.component';
import { ReloadBarComponent } from './alerts/reload-bar.component';
import { BadgeComponent } from './badge/badge.component';
import { AnchorButtonDirective, ButtonDirective, ButtonLoadingRouteDirective, LoadingButtonComponent } from './buttons/button.component';
import { PageSelectComponent } from './buttons/page-select.component';
import { PaginationComponent } from './buttons/pagination.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { RadioComponent } from './checkbox/radio.component';
import { CalendarComponent } from './date-picker/calendar.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DateRangeComponent } from './date-picker/date-range.component';
import { DropdownMenuComponent } from './dropdown/dropdown-menu.component';
import { DropdownToggleDirective } from './dropdown/dropdown-toggle.directive';
import { DropdownDirective } from './dropdown/dropdown.directive';
import { ComponentOutletDirective } from './dynamic/dynamic.component';
import { FilterInputComponent } from './forms/filter-input.component';
import { FormDateRangeComponent } from './forms/form-date-range.component';
import { FormGroupComponent } from './forms/form-group.component';
import { FormNumberRangeStepperComponent } from './forms/form-number-range-stepper.component';
import { FormNumberRangeComponent } from './forms/form-number-range.component';
import { FormPriceRangeComponent } from './forms/form-price-range.component';
import { FormRowComponent } from './forms/form-row.component';
import { PriceComponent } from './forms/price.component';
import { FaIconDirective } from './icon/fa-icon.directive';
import { GrowthArrowComponent } from './icon/growth-arrow.component';
import { IconComponent } from './icon/icon.component';
import { ImagePreloadDirective } from './images/image-preload.directive';
import { InputStepperComponent } from './input-stepper/input-stepper.component';
import { BlockCircleLoadingComponent } from './loading/block-circle-loading.component';
import { BlockLoadingComponent } from './loading/block-loading.component';
import { ModalBodyComponent } from './modals/modal-body.component';
import { ModalFooterComponent } from './modals/modal-footer.component';
import { ModalHeaderComponent } from './modals/modal-header.component';
import { ModalToolbarComponent } from './modals/modal-toolbar.component';
import { ModalComponent } from './modals/modal.component';
import { ModalsTarget } from './modals/modals-target.directive';
import { NavLinkComponent } from './navs/nav-link.component';
import { NavComponent } from './navs/nav.component';
import { TabsComponent } from './navs/tabs.component';
import { OverlaysTargetDirective } from './overlays/overlays-target.directive';
import { ProgressComponent } from './progress/progress.component';
import { SelectBoxComponent } from './select-box/select-box.component';
import { SliderComponent } from './slider/slider.component';
import { ToggleComponent } from './toggle/toggle.component';
import { CopyLinkDirective } from './tooltip/copy-link.directive';
import { InfoIconComponent } from './tooltip/info-icon.component';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { ToolbarButtonsComponent } from './window/toolbar-buttons.component';
import { ToolbarTitleComponent } from './window/toolbar-title.component';
import { ToolbarComponent } from './window/toolbar.component';
import { WindowComponent, WindowDirective } from './window/window.component';
import { ScrollButtonsComponent } from './scroll-buttons/scroll-buttons.component';


const MODULES = [
    AlertComponent,
    ReloadBarComponent,
    BadgeComponent,
    PageSelectComponent,
    AnchorButtonDirective,
    ButtonDirective,
    LoadingButtonComponent,
    ButtonLoadingRouteDirective,
    PaginationComponent,
    CheckboxComponent,
    RadioComponent,
    DatePickerComponent,
    DateRangeComponent,
    CalendarComponent,
    DropdownDirective,
    DropdownMenuComponent,
    DropdownToggleDirective,
    ComponentOutletDirective,
    IconComponent,
    FaIconDirective,
    GrowthArrowComponent,
    InputStepperComponent,
    ImagePreloadDirective,
    BlockLoadingComponent,
    BlockCircleLoadingComponent,
    OverlaysTargetDirective,
    ModalHeaderComponent,
    ModalToolbarComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    ModalComponent,
    ModalsTarget,
    NavComponent,
    NavLinkComponent,
    TabsComponent,
    FormGroupComponent,
    FormNumberRangeComponent,
    FormPriceRangeComponent,
    FormDateRangeComponent,
    FormRowComponent,
    FilterInputComponent,
    PriceComponent,
    FormNumberRangeStepperComponent,
    ProgressComponent,
    SelectBoxComponent,
    SliderComponent,
    ToggleComponent,
    TooltipDirective,
    CopyLinkDirective,
    InfoIconComponent,
    ToolbarButtonsComponent,
    ToolbarComponent,
    ToolbarTitleComponent,
    WindowComponent,
    WindowDirective,
    ScrollButtonsComponent,
];


@NgModule({
    imports: [
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ...MODULES,
    ],
    exports: [
        ...MODULES,
    ],
})
export class UiModule {}
